
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/politica-utilizare-cookie/pag",
      function () {
        return require("private-next-pages/politica-utilizare-cookie/pag/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/politica-utilizare-cookie/pag"])
      });
    }
  